import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
// import PropTypes from 'prop-types';
// import classnames from 'classnames';

// Button
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

// Uppy
import Uppy from '@uppy/core'
import Tus from '@uppy/tus'
import { DashboardModal } from '@uppy/react'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

// const Uppy = require("uppy/lib/core");
// const DashboardModal = require("uppy/lib/react/DashboardModal");
// const Tus = require("uppy/lib/plugins/Tus");

const styles = theme => ({

  fab: {
    position: 'absolute',
    bottom: 10,
    right: 10,
  }

});

class UploadModal extends Component {
  constructor (props) {
    super(props)
    this.uppy = Uppy({
          id: 'uppy',
          autoProceed: false,
          allowMultipleUploads: true,
          debug: false,
          restrictions: {
            maxFileSize: null,
            maxNumberOfFiles: null,
            minNumberOfFiles: null,
            allowedFileTypes: null
          },
          meta: {}

        }).use(Tus, { endpoint: "https://master.tus.io/files/" });

  }

  state = { modalOpen: false };

  handleUploadModalOpen = () => this.setState({ modalOpen: true });
  handleUploadModalClose = () => this.setState({ modalOpen: false });

  componentWillUnmount() {
    this.uppy.close();
  }

  render() {
    const { handleUploadCompleted } = this.props;
    const { classes } = this.props;

    // this.uppy.use(Tus, { endpoint: "https://master.tus.io/files/" });

    this.uppy.on("complete", result => {
      console.log("Completed upload, result:", result);
      const id = result.successful[0].id;
      const url = result.successful[0].uploadURL;
      handleUploadCompleted(id, url);
    });

    this.uppy.run();



    return (
      <div>
        {/*<Dashboard/>*/}
        <DashboardModal
          uppy={this.uppy}
          closeModalOnClickOutside
          open={this.state.modalOpen}
          onRequestClose={this.handleUploadModalClose}
        />

        <Fab color="primary" aria-label="Add" onClick={this.handleUploadModalOpen} className={classes.fab}>
            <AddIcon />
        </Fab>

      </div>
    );
  }
}

export default withStyles(styles)(UploadModal);
